var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_1563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.40625C14.4443 1.40723 16.8131 2.25322 18.7051 3.80085C20.597 5.34849 21.8957 7.50261 22.3812 9.89822C22.8667 12.2938 22.509 14.7836 21.3688 16.9457C20.2287 19.1078 18.3761 20.8092 16.125 21.7617C13.536 22.8557 10.6185 22.8765 8.01424 21.8194C5.40997 20.7623 3.3323 18.714 2.23828 16.125C1.14426 13.536 1.12352 10.6185 2.18061 8.01424C3.2377 5.40997 5.28603 3.3323 7.875 2.23828C9.17996 1.68605 10.583 1.40305 12 1.40625ZM12 0C5.37281 0 0 5.37281 0 12C0 18.6272 5.37281 24 12 24C18.6272 24 24 18.6272 24 12C24 5.37281 18.6272 0 12 0Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71781 11.1614H7.35516C7.02094 11.1614 6.75 11.4323 6.75 11.7665V17.9573C6.75 18.2915 7.02094 18.5625 7.35516 18.5625H8.71781C9.05203 18.5625 9.32297 18.2915 9.32297 17.9573V11.7665C9.32297 11.4323 9.05203 11.1614 8.71781 11.1614Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4811 5.4375H11.5196C11.0746 5.4375 10.7139 5.79826 10.7139 6.24328V17.7567C10.7139 18.2017 11.0746 18.5625 11.5196 18.5625H12.4811C12.9261 18.5625 13.2868 18.2017 13.2868 17.7567V6.24328C13.2868 5.79826 12.9261 5.4375 12.4811 5.4375Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5372 8.2998H15.3893C14.9958 8.2998 14.6768 8.6188 14.6768 9.0123V17.8501C14.6768 18.2436 14.9958 18.5626 15.3893 18.5626H16.5372C16.9307 18.5626 17.2497 18.2436 17.2497 17.8501V9.0123C17.2497 8.6188 16.9307 8.2998 16.5372 8.2998Z",
    fill: "#929292"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_1563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.bb9bacb16002a90a2809d5ecb1e87781.svg";
export { ForwardRef as ReactComponent };